import React from 'react';
import { PlayerOption } from './types';

interface PlayerFocusSelectProps {
  playerOptions: PlayerOption[];
  selectedPlayer: number | null;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

const PlayerFocusSelect: React.FC<PlayerFocusSelectProps> = ({ playerOptions, selectedPlayer, onChange }) => {
  return (
    <div className="mb-3">
      <select
        value={selectedPlayer ?? ''}
        onChange={onChange}
        className="w-full px-3 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-purple-500"
      >
        <option value="">Focus: All Players</option>
        {playerOptions.map(p => (
          <option key={p.playerId} value={p.playerId}>
            {p.name} ({p.position})
          </option>
        ))}
      </select>
    </div>
  );
};

export default PlayerFocusSelect;
